export default __webpack_public_path__ + "static/media/september2024-2.e686af4d.jpg";